import { createOfferResource } from './offerResourceFactory'

/**
 * Цінові пропозиції заявок (`SPEC-024` §3.3, §8) — блок «Цінові пропозиції»
 * картки власника. Ключ прав беку — `ApplicationOffer` (`ResourceCorrespondenceConfig`).
 */
export const ApplicationOfferResource = createOfferResource('application')
